/** Use the product name when displaying messages from the audit service. */
export function userFacingMessage(message: string): string {
	return message.replace(/\bhermes\b/gi, "AI Search");
}
